import {
	Component,
	ElementRef,
	Inject,
	Input,
	OnChanges,
	OnInit,
	Renderer2,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ImageService } from "../service/image.service";
import { Image } from "../../interface/image";
import { isEmptyString } from "bmx-pastebox";
import { ImageGallerySeo } from "../interface/image-gallery-seo";
import { DOCUMENT } from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {IframeDialogComponent} from "../../components-library/video/iframe-dialog/iframe-dialog.component";

@Component({
	selector: 'fb-product-image-mobile',
	templateUrl: './product-image-mobile.component.html',
	styleUrls: ['./product-image-mobile.component.scss']
})
export class ProductImageMobileComponent implements OnInit, OnChanges {


	@Input() mobileSlider: ImageGallerySeo[] = [];
	@Input() video: Image = {} as Image;
	@Input() selectedIndex: number = 0;
	@Input() addOnImagePassOn: string = '';
	public prevIndex: number = 0;

	@ViewChild('zoomDiv') zoomDiv: ElementRef = {} as ElementRef;

	public videoId: string = '';
	public videoUrl: string = '';
	public safeURL: SafeResourceUrl = '';
	public autoPlayState: boolean = true;

	constructor(
		private _sanitizer: DomSanitizer,
		private _image: ImageService,
		@Inject(DOCUMENT) private _document: Document,
		private _renderer: Renderer2,
		private _dialog: MatDialog,
	) {
	}

	public ngOnInit() {
		if (!isEmptyString(this.video.url)) {
			this.mobileSlider.splice(1, 0, { image: this.video.url, altText: this.video.altText, deleted: false });
			this.mobileSlider = [...new Set(this.mobileSlider)];
		}
	}

	public ngOnChanges(changes: SimpleChanges) {


		if (!isEmptyString(this.video.url) && (changes['video'].currentValue !== changes['video'].previousValue)) {

			this.videoUrl = this._image.getEmbeddedURL(this.video.url, true);
			this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
			let video = this.mobileSlider.find(media => media.image.includes('youtu'));
			if (video) {
				video.image = this.videoUrl;
			}
			this.mobileSlider = [...new Set(this.mobileSlider)];
		}
		if (!isEmptyString(this.addOnImagePassOn)) {
		}

		if ((changes['addOnImagePassOn'].currentValue !== changes['addOnImagePassOn'].previousValue)) {
			if (isEmptyString(changes['addOnImagePassOn'].previousValue) && !isEmptyString(changes['addOnImagePassOn'].currentValue)) {
				this.mobileSlider.splice(0, 0, {
					image: this.addOnImagePassOn,
					altText: this.video.altText,
					deleted: false
				});
				this.mobileSlider = [...new Set(this.mobileSlider)];
			}
			else if (!isEmptyString(changes['addOnImagePassOn'].previousValue) && !isEmptyString(changes['addOnImagePassOn'].currentValue)) {
				this.mobileSlider[0].image = this.addOnImagePassOn;
			}
			else if (isEmptyString(changes['addOnImagePassOn'].currentValue)) {
				if (this.mobileSlider[0].image === changes['addOnImagePassOn'].previousValue) {
					this.mobileSlider.splice(0, 1);
				}
			}
			this.selectedIndex = 0;
		}
	}

	public onTouchStart($event: MouseEvent) {
		this.autoPlayState = !this.autoPlayState;
		this.videoUrl = this._image.getEmbeddedURL(this.video.url, this.autoPlayState);
		this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
	}

	public switchImage(index: number): void {
		this.prevIndex = this.selectedIndex;
		this.selectedIndex = index;
		let element: HTMLElement | null = null;
		if(this.mobileSlider[this.selectedIndex].image.includes('youtu')){
			element = this._document.getElementById('id-pig-image-card-video');
		}
		else {
			element = this._document.getElementById('id-pig-image-card');
		}
		//this._renderer.setStyle(this.zoomDiv.nativeElement, "display", 'none');

		if(element === null) return;
		if(this.prevIndex < this.selectedIndex){
			this.restart_animation(element, 'slide-in-right 0.5s ease-out ');
		}
		else if(this.prevIndex > this.selectedIndex){
			this.restart_animation(element, 'slide-in-left 0.5s ease-out ');
		}
	}

	public reset(): void {
		this.switchImage(0);
	}

	public zoom(e: any): void {
		if (screen.width > 759) {
			const { offsetX, offsetY } = e;
			const offsetWidth = e.currentTarget.offsetWidth;
			const offsetHeight = e.currentTarget.offsetHeight;
			const x = offsetX / offsetWidth * 100;
			const y = offsetY / offsetHeight * 100;
			const pos = `${x}% ${y}%`;
			this._renderer.setStyle(e.currentTarget, "background-position", pos);

			if (this.mobileSlider[this.selectedIndex].image) {
				this._renderer.setStyle(
					this.zoomDiv.nativeElement,
					"background-image",
					`url(${this.mobileSlider[this.selectedIndex].image})`
				);
			}
		}


	}

	public zoomOut(): void {
		this._renderer.setStyle(
			this.zoomDiv.nativeElement,
			"background-image",
			`url()`
		);
	}

	public nextImage(index: number): void {
		if (index < this.mobileSlider.length - 1) {
			this.switchImage(index + 1);
		}

	}

	public prevImage(index: number): void {
		if (index > 0) {
			this.switchImage(index - 1);
		}

	}

	public restart_animation(element: HTMLElement, animationName: string) {
		element.style.animation = 'none';
		element.offsetHeight;
		window.requestAnimationFrame(() => {
			element.style.animation = animationName + ' forwards';

		});

	}

	public addOnImageSelect(): void {
		this.selectedIndex = 0
	}

	public openVideoDialog(): void {
		this._dialog.open(IframeDialogComponent, {
			data: this.safeURL,
			maxWidth: '95vw',
			maxHeight: '90vh',
		})
	}
}
